module.exports = __webpack_public_path__ + "img/green-desktop.c2cf0267.png";